import React from 'react'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { useTheme } from 'styled-components'
import RiRadioButtonFill from '@meronex/icons/ri/RiRadioButtonFill'
import MdRadioButtonUnchecked from '@meronex/icons/md/MdRadioButtonUnchecked'

import {
  Container,
  GiftCardsListContainer,
  GiftCardsWrapper,
  GiftCardItem,
  IconControl,
  ActionButtonContainer,
  CardImage,
  CardImageStyled
} from './styles'

import { useLanguage, useUtils, PurchaseGiftCard as PurchaseGiftCardController } from '~components'
import { Button, NotFoundSource } from '~ui'

const PurchaseGiftCardUI = (props) => {
  const {
    productsListState,
    selectedProduct,
    setSelectedProduct,
    handleAccept,
    isPage
  } = props

  const theme = useTheme()
  const [, t] = useLanguage()
  const [{ optimizeImage, parsePrice }] = useUtils()

  const handleProductSelection = (product) => {
    setSelectedProduct(product)
    if (isPage) {
      handleAccept(product)
    }
  }

  return (
    <Container>
      <GiftCardsListContainer>
        <p>{t('SELECT_GIFT_CARD', 'Select your gift card')}</p>
        <GiftCardsWrapper>
          {productsListState.loading && (
            [...Array(5).keys()].map(i => (
              <GiftCardItem key={i}>
                <IconControl>
                  <Skeleton width={16} height={16} />
                </IconControl>
                <CardImageStyled>
                  <Skeleton width={38} height={38} />
                </CardImageStyled>
                <Skeleton width={100} />
              </GiftCardItem>
            ))
          )}
          {productsListState.products.map(product => (
            <GiftCardItem
              key={product.id}
              onClick={() => handleProductSelection(product)}
              isPage={isPage}
            >
              <div className='left-content'>
                {!isPage && (
                  <IconControl>
                  {selectedProduct?.id === product.id
                    ? (
                    <RiRadioButtonFill />
                      )
                    : (
                    <MdRadioButtonUnchecked disabled />
                      )}
                  </IconControl>
                )}
                <div>
                  <CardImage
                    bgimage={optimizeImage(product?.image || theme?.images?.dummies?.giftCard, 'h_86,c_limit')}
                  />
                </div>
                <div>
                  <p className='name'>{product?.name}</p>
                  <p className='price'>{parsePrice(product?.price)}</p>
                </div>
              </div>
              <Button color='green'>
                {t('PURCHASE', 'Purchase')}
              </Button>
            </GiftCardItem>
          ))}
          {!productsListState.loading && productsListState.products.length === 0 && (
            <NotFoundSource />
          )}
        </GiftCardsWrapper>
      </GiftCardsListContainer>
      {!isPage && (
        <ActionButtonContainer>
          <Button
            type='button'
            color='primary'
            disabled={!selectedProduct}
            onClick={() => handleAccept()}
          >
            {t('ACCEPT', 'Accept')}
          </Button>
        </ActionButtonContainer>
      )}
    </Container>
  )
}

export const PurchaseGiftCard = (props) => {
  const purchaseGiftCardProps = {
    ...props,
    UIComponent: PurchaseGiftCardUI
  }
  return <PurchaseGiftCardController {...purchaseGiftCardProps} />
}
